module.exports = __webpack_public_path__ + "img/cascade-btn-chart.4cb38a83.png";